import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthSharedService } from '@core-lib/services/auth.service';
import { environment } from '@environments/environment';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

@Injectable()
export class MailService {
	get tenantKey() {
		return this.authService.currentTenantKey;
	}

	constructor(
		protected store$: Store,
		private http: HttpClient,
		private authService: AuthSharedService
	) {}

	sendMailWithAttachedFiles(form: any): Observable<any> {
		const formData = new FormData();

		this.appendCommonFormData(form, formData);
		if (form.evenementId != null) {
			formData.append('evenementId', form.evenementId);
		}
		if (form.courrierId != null) {
			formData.append('courrierId', form.courrierId);
		}

		return this.http.post<any>(`${environment.apiUrl}/t/${this.tenantKey}/email/sendMailWithDocuments`, formData);
	}

	sendMailContactFO(form: any): Observable<boolean> {
		const formData = new FormData();
		this.appendCommonFormData(form, formData);

		if (form.affaireId != null) {
			formData.append('affaireId', form.affaireId);
		}
		if (form.compteId != null) {
			formData.append('compteId', form.compteId);
		}

		return this.http.post<boolean>(`${environment.apiUrl}/t/${this.tenantKey}/email/sendMailContact/FO`, formData);
	}

	deleteCourrier(courrierId: string): Observable<any> {
		return this.http.delete<any>(`${environment.apiUrl}/t/${this.tenantKey}/modeleDocument/courrier/${courrierId}`);
	}

	private appendCommonFormData(form: any, formData: FormData): void {
		// Upload attached documents

		for (let i = 0; i < form?.attachedDocument?.filesList?.length; i++) {
			if (form.attachedDocument?.filesList[i].id != null) {
				formData.append('attachedDocument[' + i + '][id]', form.attachedDocument?.filesList[i].id);
				formData.append('attachedDocument[' + i + '][libelle]', form.attachedDocument?.filesList[i].name);
			} else {
				formData.append('attachedDocument[' + i + '][file]', form.attachedDocument?.filesList[i].file);
				formData.append('attachedDocument[' + i + '][libelle]', form.attachedDocument?.filesList[i].libelle);
				formData.append('attachedDocument[' + i + '][commentaire]', form.attachedDocument?.filesList[i].commentaire);
			}
		}
		formData.append('sender', form.sender?.trim());
		formData.append('receiver', form.receiver);
		formData.append('subject', form.subject);
		formData.append('body', form.body);

		if (form.ccMe) {
			formData.append('isCCMe', form.ccMe);
		}

		for (let i = 0; i < form?.ccReceivers?.length; i++) {
			formData.append('ccReceivers', form?.ccReceivers[i]);
		}
	}
}
